/**
 * useRefundActions Hook
 *
 * Calls the processRefundAdmin Cloud Function to approve/reject requests.
 */

import { useState, useCallback } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

interface ProcessRefundParams {
  refundRequestId: string;
  action: 'approve' | 'reject';
  amount?: number;
  reason?: string;
  manualReference?: string;
}

interface ProcessRefundResult {
  success: boolean;
  action: string;
  refundAmount?: number;
  stripeRefundId?: string | null;
}

export const useRefundActions = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const processRefund = useCallback(
    async (params: ProcessRefundParams): Promise<ProcessRefundResult> => {
      setIsProcessing(true);
      try {
        const fn = httpsCallable<ProcessRefundParams, ProcessRefundResult>(
          functions,
          'processRefundAdmin'
        );
        const result = await fn(params);
        return result.data;
      } finally {
        setIsProcessing(false);
      }
    },
    []
  );

  return { processRefund, isProcessing };
};

export default useRefundActions;
